"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Link = require("./Link");

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SrHeaderArea = function SrHeaderArea(_ref) {
  var _ref$Link = _ref.Link,
      Link = _ref$Link === undefined ? _Link2.default : _ref$Link;
  return _react2.default.createElement(
    "div",
    { id: "sr-header-area" },
    _react2.default.createElement(
      "div",
      { className: "width-clip" },
      _react2.default.createElement(
        "div",
        { className: "dropdown srdrop" },
        _react2.default.createElement(
          "span",
          { className: "selected title" },
          "THIS IS NOT REDDIT.COM!"
        )
      ),
      _react2.default.createElement(
        "div",
        { className: "drop-choices srdrop" },
        _react2.default.createElement(
          Link,
          { className: "choice", href: "/r/all/" },
          "all"
        ),
        _react2.default.createElement(
          Link,
          {
            className: "bottom-option choice",
            href: "/subreddits/"
          },
          "edit subscriptions"
        )
      ),
      _react2.default.createElement(
        "div",
        { className: "sr-list" },
        _react2.default.createElement(
          "ul",
          { className: "flat-list sr-bar hover" },
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement(
              Link,
              { className: "choice", href: "/" },
              "front"
            )
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement(
              "span",
              { className: "separator" },
              "-"
            ),
            _react2.default.createElement(
              Link,
              { className: "choice", href: "/r/all" },
              "all"
            )
          )
        ),
        _react2.default.createElement(
          "span",
          { className: "separator" },
          "\xA0|\xA0"
        ),
        _react2.default.createElement(
          "ul",
          { className: "flat-list sr-bar hover" },
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement(
              Link,
              { className: "choice", href: "/r/decred/" },
              "Decred"
            )
          )
        ),
        _react2.default.createElement(
          "span",
          { className: "separator" },
          "\xA0|\xA0"
        ),
        _react2.default.createElement("ul", { className: "flat-list sr-bar hover", id: "sr-bar" })
      ),
      _react2.default.createElement(
        Link,
        { href: "/subreddits/", id: "sr-more-link" },
        "edit \xBB"
      )
    )
  );
};

exports.default = SrHeaderArea;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/SrHeaderArea.js
// module id = 314
// module chunks = 0